module.exports = __webpack_public_path__ + "static/civil adjudication law-72ecd1f33017bc0e842a62e45e5b1be8.jpg";